// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the location mark icon.
 *
 * @component
 * @param {IconProps} props - The IconProps for the LocationMarkIcon component.
 * @returns {ReactElement} The LocationMarkIcon component.
 */
export const LocationMarkIcon = (props: IconProps) => {
  const { color = '#C1C1CF', ...rest } = props;
  return (
    <Icon w='13' h='17' viewBox='0 0 13 17' color={color} {...rest}>
      <path
        id='Vector'
        d='M5.52141 16.1772C0.864423 9.59472 0 8.91916 0 6.5C0 3.18628 2.75516 0.5 6.15385 0.5C9.55253 0.5 12.3077 3.18628 12.3077 6.5C12.3077 8.91916 11.4433 9.59472 6.78628 16.1772C6.48067 16.6076 5.82699 16.6076 5.52141 16.1772ZM6.15385 9C7.56997 9 8.71795 7.88072 8.71795 6.5C8.71795 5.11928 7.56997 4 6.15385 4C4.73772 4 3.58974 5.11928 3.58974 6.5C3.58974 7.88072 4.73772 9 6.15385 9Z'
        fill='currentColor'
      />
    </Icon>
  );
};
